import React from 'react';
import API from "../base/API";
import Auth from "../auth/Auth";
import { hasPermission } from "../auth/Auth";
import Link from "../base/Link";
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';
import DeleteButton from "../base/DeleteButton";
import { translate } from '../base/Translation';

const SortableItem = SortableElement(({ error, mainComponent }) =>
    <tr key={error.id} className="row">
        <td className="col-md-2">
            <Link
                to={"/error_result/edit/" + error.result}
                permission={hasPermission("ErrorResultEdit", mainComponent.props.test)}
                textIfNoAccess={true}
                style={{ color: error.successful ? "black" : "red" }}>
                {error.component}
            </Link>
        </td>
        <td className="col-md-3">{error.state_before}</td>
        <td className="col-md-3">{error.required_state}</td>
        <td className="col-md-3" style={{ color: error.successful ? "black" : "red" }}>{error.state_after}</td>
        <td className="col-md-1" style={{ color: error.successful ? "black" : "red" }}>{error.successful ? translate("Áno") + " (" + error.points + ")" : translate("Nie") + " (" + error.negative_points + ")"}</td>
        <td className="col-md-1">
            <DeleteButton
                onClick={() => { mainComponent.deleteAnswer(error.result); }}
                permission={hasPermission("ErrorResultDelete", mainComponent.props.test)} />
        </td>
    </tr>
);

const SortableList = SortableContainer(({ items, mainComponent }) => {
    return (
        <tbody>
            {items.map((data, index) => (
                <SortableItem key={data.id} index={index} error={data} mainComponent={mainComponent} />
            ))}
        </tbody>
    );
});

export default class ErrorDBTestTable extends Auth {

    constructor(props) {
        super(props);

        this.api = new API({
            get_error_db: "/error/fetch/test_errors/:database/:protocol/:test",
            reorder_errors: "/error/reorder",
            delete_error_answer: "/error/answer/delete/:answer"
        });

        this.state = {
            form: false,
            error_db: false,
            answers: false
        };
    }

    async fetchData() {
        this.api.request({
            route: "get_error_db",
            params: {
                protocol: this.props.protocol.id,
                database: this.props.protocol.error_db,
                test: this.props.test.id
            },
            success: function (response) {
                this.setState({ error_db: response });
            }.bind(this)
        });
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(nextProps) {
        if (nextProps.test !== this.props.test) {
            this.fetchData();
        }
    }

    onSortEnd = ({ oldIndex, newIndex }) => {

        if (!hasPermission("ErrorResultEdit", this.props.test)) {
            return;
        }

        let newOrder = arrayMove(this.state.error_db, oldIndex, newIndex);
        let jsonData = [];

        newOrder.forEach(function (error, index) {
            error["position"] = index;
            jsonData.push({ "id": error.result, "position": index });
        });


        this.api.request({
            route: "reorder_errors",
            data: jsonData,
            created: function (response) {
                // do nothing
            }
        });

        this.setState({ error_db: newOrder });
    };

    deleteAnswer(answer) {

        this.api.request({
            route: "delete_error_answer",
            params: { "answer": answer },
            success: function (response) {
                this.fetchData();
            }.bind(this)
        });
    }

    render() {

        if (!this.state.error_db) {
            return (
                <div className="row">
                    <div className="col-xs-12 col-md-6">
                        <br /> {translate("Načítava sa...")}
                    </div>
                </div>
            );
        }


        return (
            <div>
                <div className="panel panel-default">
                    <div className="panel-heading">
                        {translate("Hodnotené procesy, komponenty a parametre")}
                        <Link
                            to={"/error_result/add/" + this.props.test.id + "/" + this.props.protocol.id}
                            permission={hasPermission("ErrorResultNew", this.props.test)}
                            className="btn btn-primary btn-xs pull-right">
                            {translate("Pridať")}
                        </Link>
                    </div>
                    <div className="panel-body">
                        <table className="table table-hover table-responsive" style={{ marginBottom: 0 }}>
                            <thead>
                                <tr className="row">
                                    <th className="col-md-2">{translate("Predmet kontroly")}</th>
                                    <th className="col-md-3">{translate("Stav pred testom")}</th>
                                    <th className="col-md-3">{translate("Požadovaný stav")}</th>
                                    <th className="col-md-3">{translate("Stav po teste")}</th>
                                    <th className="col-md-1">{translate("Vyhovel (body)")}</th>
                                    <th className="col-md-1"> </th>
                                </tr>
                            </thead>
                            <SortableList items={this.state.error_db} lockAxis="y" onSortEnd={this.onSortEnd} mainComponent={this} pressDelay={hasPermission("ErrorResultEdit") ? 1000 : 9999999} />
                        </table>
                        <br />
                        {this.state.error_db.map(function (error, index) {
                            if (error.note === "") {
                                return false;
                            }
                            return (
                                <div className="error_result_note" key={index}>
                                    <i>{error.component} - <span style={{ fontWeight: "300" }} >{error.note}</span></i>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/error_db/ErrorDBTestTable.js